import React from "react";
import Nav from "../Navs/Nav";
import Logo from "../UI/Logo";
import SocialIcons from "../UI/SocialIcons";

let navs = [
  {
    id: 1,
    label: "Home",
    link: "/",
  },
  {
    id: 2,
    label: "Menu",
    link: "/menu",
  },
  {
    id: 3,
    label: "About Us",
    link: "/about",
  },
  {
    id: 4,
    label: "Contact Us",
    link: "/contact",
  },
];

export default function Footer() {
  return (
    <footer className="py-4 bg-secondary mt-5">
      <div className="container">
        <div className="row">
          <div className="col-md-3">
            <Logo classes="text-white" spanClass="text-white" />
          </div>
          <div className="col-md-6">
            <Nav linkColor="text-white" navArr={navs} position="center" />
          </div>
          <div className="col-md-3">
            <SocialIcons position="end" color="text-white" />
          </div>
        </div>
      </div>
    </footer>
  );
}
